// extracted by mini-css-extract-plugin
export default {"container":"IFFilterSkeleton_container__Ss9ho"};